// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__jghVh","title":"ClientReferral_title__1FGM9","itemText":"ClientReferral_itemText__b-KvC"};